import CustomText, { textStyles } from "../../components/CustomText";
import { Box, Grid } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomButton from "../../components/CustomButton";
import more from "../../assets/more.svg";
import accessiblehero1 from "../../assets/accessiblehero1.webp";
import accessiblehero2 from "../../assets/accessiblehero2.webp";
import accessiblehero3 from "../../assets/accessiblehero3.webp";
import accessiblehero4 from "../../assets/accessiblehero4.webp";
import FeatureCard from "../../components/cards/FeatureCard";
import AccessibleCard from "../../components/cards/AccessibleCard";

import { useTranslation } from "react-i18next";
const AccessibilityCardsSection = () => {
  const { t, i18n } = useTranslation();

  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // e.g. below 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };

  const featureData = [
    
    {
      icon: <img src={accessiblehero1} alt="Feature 1"/>, // Replace with your actual icon
      title: t("accessibility.0.title"),
      description: t("accessibility.0.description"),
      variant: "light", // Can be "light" or "dark"
    },
    {
      icon: <img src={accessiblehero2} alt="Feature 2" />, // Replace with your actual icon
      title: t("accessibility.1.title"),
      description: t("accessibility.1.description"),
      variant: "light", // Can be "light" or "dark"
    },
    {
      icon: <img src={accessiblehero3} alt="Feature 3"    />, // Replace with your actual icon
      title: t("accessibility.2.title"),
      description: t("accessibility.2.description"),
      variant: "light", // Can be "light" or "dark"
    },
    {
      icon: <img src={accessiblehero4} alt="Feature 4"       />, // Replace with your actual icon
      title: t("accessibility.4.title"),
      description: t("accessibility.4.description"),
      variant: "light", // Can be "light" or "dark"
    },


  ];
  return (
    <Box
      sx={{
        marginTop: "20px",
        paddingTop: isMobile ? "100px" : "40px",
        paddingBottom: "60px",
        position: "relative",
        px: isMobile ? 2 : isTablet ? 2 : 40,

      }}
    >
      <div
        style={{
          marginTop: isMobile ? "-120px" : "0px",
        }}
      >
        <CustomText
          style={{
            ...textStyles.h3,
fontSize:isMobile?"40px":"48px",
            color: "#072533",
            maxWidth: "1200px",
            margin: "0 auto",
            textAlign:"center",
          
          }}
        >
          {t("accessibility_heading")}
        </CustomText>
      </div>
      <CustomText
        style={{
          ...textStyles.body2,
          color: "#868282",
          maxWidth: "1050px",
          textAlign: "center",
          margin: "0 auto",
          marginTop: "30px",
        }}
      >

        {t("accessibility_subtext")}
      </CustomText>
      <Box
        sx={{
          display: "flex",
          flexWrap: isMobile ? "wrap" : "wrap",
          justifyContent: "center",
          gap: "30px",
          marginTop: "40px",
        }}
      >
        {featureData.map((feature, index) => (
          <Box
            key={index}
            sx={{
              // width: isMobile ? "100%" : "calc(33.333% - 20px)",
              width: isMobile
                ? "100%"
                : isTablet
                ? "calc(50% - 15px)"
                : "calc(50% - 15px)",
              boxSizing: "border-box",
              cursor: "pointer",
            }}
          >
            <AccessibleCard
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              variant="light"
            />
          </Box>
        ))}
      </Box>

    </Box>
  );
};

export default AccessibilityCardsSection;
